/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    view: 'Dashboard'
  },
  {
    path: '/apps',
    name: 'Applications',
    view: 'Applications',
  },
  {
    path: '/apps/:id',
    name: 'Application',
    view: 'Application',
  },
  {
    path: '/subs',
    name: 'Subscriptions',
    view: 'Subscriptions'
  },
  {
    path: '/subs/:id',
    name: 'Subscription',
    view: 'Subscription'
  },
  {
    path: '/system',
    name: 'System',
    view: 'System'
  },
  {
    path: '/logout',
    name: 'Logout',
    view: 'Logout'
  },
  {
    path: '/auth',
    name: 'OidcCallback',
    view: 'OidcCallback',
    meta: {
      isOidcCallback: true,
      isPublic: true
    }
  },
  {
    path: '/silent-renew',
    name: 'OidcSilentRenewCallback',
    view: 'OidcSilentRenewCallback',
    meta: {
      isOidcCallback: true,
      isPublic: true
    }
  },
  {
    path: '/signout',
    name: 'OidcSignOutCallback',
    view: 'OidcSignOutCallback',
    meta: {
      isOidcCallback: true,
      isPublic: true
    }
  },
]
